import { makeInlineText } from './internal/makeInlineText';
/**
 * @deprecated используйте Paragraph1 или Body1
 */

export var InlineText1 = makeInlineText({
  fontSize: '16px',
  lineHeight: '22px'
});
/**
 * @deprecated используйте Paragraph2 или Body2
 */

export var InlineText2 = makeInlineText({
  fontSize: '14px',
  lineHeight: '20px'
});
/**
 * @deprecated используйте Paragraph3 или Body3
 */

export var InlineText3 = makeInlineText({
  fontSize: '12px',
  lineHeight: '18px'
});
/**
 * @deprecated используйте Overline
 */

export var InlineText4 = makeInlineText({
  fontSize: '10px',
  lineHeight: '16px'
});